"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = void 0;

var _styledComponents = require("styled-components");

var _Theme = require("./Theme.variables");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    @media (min-width: ", ") {\n      ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Iterate through the breakpoints and create a media template


var media = Object.keys(_Theme.breakpoints).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject(), _Theme.breakpoints[label], _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.media = media;